import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  trello: {
    authorized: 0,
    auth_date: null
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
